import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-4ff3a2d2")

_pushScopeId("data-v-4ff3a2d2")
const _hoisted_1 = { class: "discount-line" }
const _hoisted_2 = { class: "discount column-1" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Jméno", -1)
const _hoisted_4 = { class: "value" }
const _hoisted_5 = { class: "discount column-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("p", { class: "title" }, "E-mail", -1)
const _hoisted_7 = { class: "value" }
const _hoisted_8 = { class: "discount column-3" }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", { class: "title" }, "Telefon", -1)
const _hoisted_10 = { class: "value" }
const _hoisted_11 = { class: "discount column-4" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.consumer.name), 1)
    ]),
    _createVNode("div", _hoisted_5, [
      _hoisted_6,
      _createVNode("p", _hoisted_7, _toDisplayString(_ctx.consumer.email), 1)
    ]),
    _createVNode("div", _hoisted_8, [
      _hoisted_9,
      _createVNode("p", _hoisted_10, _toDisplayString(_ctx.consumer.phone), 1)
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode("button", {
        class: "button-delete",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.removeConsumer(_ctx.index, _ctx.consumer)))
      }, "Smazat")
    ])
  ]))
})